const PREFIX = '/v1/WorkFlow/ZhengbuShenhe'

export const URL = {
  ADD: PREFIX + '/add',
  MULTIPLE_ADD: PREFIX + '/addBatch'
}
